import { render, staticRenderFns } from "./navGrid.vue?vue&type=template&id=28d11e50"
import script from "./navGrid.vue?vue&type=script&lang=js"
export * from "./navGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports